import PoweredByImg from "../../assets/images/poweredByImg.svg";
import SurveyButton from "../UserInput/Buttons/SurveyButton";
import "../../css/survey.scss";
import Textbox from "components/UserInput/Textbox";

const HeroPage = ({ setStart, themeColors, disableStartButton, advisorDirectLink, name, setName }) => {
    const onStartAssessment = () => {
        setStart(true);
    };
    
    return (
        <div
            className="md:pt-40"
            style={{
                background: themeColors.primaryColor,
                minHeight: "100%",
            }}
        >
            <div
                className="
                    hidden md:flex
                    flex-row justify-between
                    mb-8 w-full
                    md:px-7 lg:px-9 xl:px-40 2xl:px-64
                "
            >
                <img alt="" src={themeColors.appLogo} className="h-16"/>
                <img alt="" src={themeColors.mainLogo} className="h-fit max-h-16"/>
            </div>
            <div className="flex items-start md:justify-between w-full space-x-20 px-[48px] md:px-7 lg:px-9 xl:px-40  2xl:px-64">
                <main className="flex-1 flex flex-col w-full mb-10">
                    <div className="flex md:hidden items-center justify-between overflow-hidden h-28 md:mb-[30px]">
                        <div className="block md:hidden">
                            <img alt="" src={themeColors.appLogo} style={{ height: "3rem", float: "left" }} />
                        </div>
                        <div className="block md:hidden">
                            <img alt="" src={themeColors.mainLogo} style={{height: "3rem"}}/>
                        </div>
                    </div>
                    <h1 className="survey-landing-page-heading mb-10">Get Your Score</h1>
                    <div className="survey-landing-page-text mb-10">{themeColors.callToAction.description}</div>
                    <div>
                        {advisorDirectLink && (
                            <>
                                <div className="survey-landing-page-text mb-5">
                                Please enter your name to continue:
                                </div>
                                <div className="mb-10">
                                    <Textbox placeholder="Full Name" value={name} onChange={setName}/>
                                </div>
                            </>
                        )}
                        <SurveyButton
                            size={{ fontSize: "14pt", paddingX: "20px", paddingY: "13px" }}
                            colorTheme={themeColors}
                            handleOnClick={onStartAssessment}
                            disabled={disableStartButton || (advisorDirectLink && !name)}
                        >
                            {themeColors.callToAction.buttonText}
                        </SurveyButton>
                    </div>
                </main>
                <div className="flex-1 md:flex md:flex-col md:justify-end md:items-end md:gap-4 hidden relative">
                    <img className="rounded-xl w-[500px]" src={themeColors.landingImage} alt="" />
                    <img src={PoweredByImg} alt="" className="w-[87px] h-[67px]" />
                </div>
            </div>
        </div>
    );
};

export default HeroPage;
